"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpCenterTray = HelpCenterTray;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _core = require("@linaria/core");
var _icon = require("@site/pattern-library-utils/icon");
var _menu = _interopRequireDefault(require("../other/menu/"));
var _menuItem = _interopRequireDefault(require("../other/menu/menu-item"));
var _actions = _interopRequireDefault(require("../../elements/other/actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HelpCenterTrayContainer = /*#__PURE__*/(0, _react2.styled)("details")({
  name: "HelpCenterTrayContainer",
  class: "pl-h192acyx"
});
const HelpCenterSummary = /*#__PURE__*/(0, _react2.styled)("summary")({
  name: "HelpCenterSummary",
  class: "pl-h5agc0z"
});
const Caret = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Caret",
  class: "pl-c17hmg41"
});
const TrayClose = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "TrayClose",
  class: "pl-t1qb1lin"
});
const Flyout = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Flyout",
  class: "pl-fr1o3ak"
});
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonContainer",
  class: "pl-b1d1xool"
});
const Stopper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Stopper",
  class: "pl-s1mu51ht"
});
const Overlay = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Overlay",
  class: "pl-odrpb2p"
});
const TrayLabel = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "TrayLabel",
  class: "pl-tc7vnze"
});
const HelpIcon = "pl-h17h704n";
const HelpMenus = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HelpMenus",
  class: "pl-h1hri1he"
});
function closeTray(trayRef) {
  trayRef.current.removeAttribute('open');
}

/**
 * Account Tray component.
 * @param {Object} props React props
 * @param {string} trayLabel Tray Label
 * @param {string} ariaLabel Aria Label
 * @param {array} menus Menus with links
 * @param {string} props.partial theme partial to apply
 * @param {React.ReactElement} ctas CTAs
* @returns {React.ReactElement} Help Center Tray
 * @public
 */

function HelpCenterTray({
  id,
  trayLabel,
  ariaLabel,
  menus,
  ctas,
  partial = 'light1'
}) {
  const helpTrayRef = (0, _react.useRef)(null);
  const handleClick = ({
    target
  }) => {
    if (helpTrayRef.current.contains(target)) {
      return;
    }
    closeTray(helpTrayRef);
  };
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', handleClick);
      return () => {
        document.removeEventListener('mousedown', handleClick);
      };
    }
  }, []);
  const menusArr = menus?.map((menu, i) => {
    const menuItems = menu.menuItems.map((menuItem, j) => {
      return /*#__PURE__*/_react.default.createElement(_menuItem.default, {
        key: `help-center-tray-menu-${i}-menu-item-${j}`,
        text: menuItem.title,
        link: menuItem.href
      });
    });
    return /*#__PURE__*/_react.default.createElement(_menu.default, {
      key: `help-center-tray-menu-${i}`
    }, menuItems);
  });
  if (ctas) {
    ctas = ctas.map(cta => {
      return {
        ...cta,
        design: 'primary',
        templateName: 'Button Component',
        width: 'full'
      };
    });
  }
  return /*#__PURE__*/_react.default.createElement(HelpCenterTrayContainer, {
    id: `id-${id}`,
    ref: helpTrayRef,
    ariaLabel: ariaLabel,
    "data-cy": "helpcenter-tray"
  }, /*#__PURE__*/_react.default.createElement(HelpCenterSummary, null, /*#__PURE__*/_react.default.createElement(TrayLabel, null, trayLabel, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down",
    fill: _intents.default.ux.box.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "help",
    className: HelpIcon,
    fill: _intents.default.ux.box.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(Caret, {
    "data-partial": partial
  }), /*#__PURE__*/_react.default.createElement(Flyout, {
    tabIndex: "-1",
    "data-partial": partial
  }, /*#__PURE__*/_react.default.createElement(TrayClose, {
    onClick: () => {
      closeTray(helpTrayRef);
    }
  }), menus && /*#__PURE__*/_react.default.createElement(HelpMenus, null, menusArr), ctas && /*#__PURE__*/_react.default.createElement(ButtonContainer, null, /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: ctas
  })), /*#__PURE__*/_react.default.createElement(Stopper, {
    tabIndex: "0",
    onFocus: () => {
      closeTray(helpTrayRef);
    }
  })), /*#__PURE__*/_react.default.createElement(Overlay, {
    onClick: () => {
      closeTray(helpTrayRef);
    }
  }));
}
HelpCenterTray.propTypes = {
  id: _propTypes.default.string,
  trayLabel: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  menus: _propTypes.default.array,
  ctas: _propTypes.default.element,
  partial: _propTypes.default.string
};
var _default = exports.default = HelpCenterTray;